import { useEffect, useRef } from "react";
import { useLocalization } from "@fluent/react";
import { Alert } from "@narmi/design_system";

const ACHCompanyMissingAlert = ({
  isActive,
  // the single ACH payment step is long enough that the alert is off-screen by
  // the time the account is picked, so that flow opts into scrolling to it
  shouldScrollIntoView = false,
}: {
  isActive: boolean;
  shouldScrollIntoView?: boolean;
}) => {
  const { l10n } = useLocalization();
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!isActive || !shouldScrollIntoView) return;

    const element = containerRef.current;
    if (!element || typeof element.scrollIntoView !== "function") return;

    const { top, bottom } = element.getBoundingClientRect();
    const isInViewport = top >= 0 && bottom <= window.innerHeight;
    if (isInViewport) return;

    element.scrollIntoView({ behavior: "smooth", block: "center" });
  }, [isActive, shouldScrollIntoView]);

  if (!isActive) return null;

  return (
    <div ref={containerRef}>
      <Alert kind="error" isActive isDismissable={false}>
        <span>{l10n.getString("ach-company-missing-alert")}</span>
      </Alert>
    </div>
  );
};

export default ACHCompanyMissingAlert;
